import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/sports/mobile/empty-hot-match.png")